export const REIMBURSEMENT_STATUSES = [
  { label: 'All', value: 0, color: '#A88' },
  { label: 'Pending', value: 1, color: '#FFFF00' },
  { label: 'Submitted', value: 2, color: '#0000FF' },
  { label: 'Approved', value: 3, color: '#080' },
  { label: 'Rejected', value: 4, color: '#D00' },
  { label: 'Processed', value: 5, color: '#CCC' },
];
